// The shared cookie is scoped to the parent domain so every *.honeyfund.com
// property (main site, CMS, mkt-emails) can read the same decision.
var SHARED_COOKIE_DOMAIN = '.honeyfund.com';

/**
 * This popup needs to work on as many browsers as possible and with all the
 * frameworks we've got, so this JS gets very vanilla at times.
 */
if (!cookieIsSet()) {
    const espanol = {
        html: 'Usamos cookies y otras tecnologías de rastreo para recordar tus preferencias, personalizar tu experiencia y entender cómo los visitantes usan Honeyfund. Consulta nuestra <a style="text-decoration:underline;color:white;" href="/Privacy">Política de privacidad</a> y nuestros <a style="text-decoration:underline;color:white;" href="/Terms">Términos de Uso</a>.',
        buttonText: 'Aceptar todo',
        necessaryButtonText: 'Solo necesarias',
    };
    const english = {
        html: 'We use cookies and other tracking technology to remember your preferences, personalize your experience, and understand how visitors use Honeyfund. See our <a style="text-decoration:underline;color:white;" href="/Privacy">Privacy Policy</a> and <a style="text-decoration:underline;color:white;" href="/Terms">Terms of Use</a>.',
        buttonText: 'Accept All',
        necessaryButtonText: 'Necessary Only',
    };
    const html = require('./popup.html');
    const lang = /fondodemiel/.test(location.hostname)
        ? espanol
        : english;

    // This box will contain our popup and hold open some space for it at the
    // bottom of the page (with the help of `popupMock`)
    const box = document.createElement('div');
    document.body.classList.add("has-cookie-banner");
    document.body.appendChild(box);

    const removeBox = function () {
        clearInterval(kingMaker);
        transitionOut(box, popup, function () {
            box.parentNode.removeChild(box);
            document.body.classList.remove("has-cookie-banner");
        });
    };

    const onAcceptAll = function () {
        setCookie('accepted', 179);
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage: 'granted',
                analytics_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted'
            });
        }
        
        window.VWO = window.VWO || [];
        window.VWO.push(['optInVisitor']);
        
        removeBox();
    };
 
    const onNecessaryOnly = function () {
        setSessionCookie();
        removeBox();
    };

    // Build the popup and put it in the box
    const popup = buildPopup(html, lang, removeBox, onAcceptAll, onNecessaryOnly);
    box.appendChild(popup);

    // This element will make the page grow by the size of the popup and so
    // ensure the popup doesn't hide anything that exists in the normal flow.
    const popupMock = popup.cloneNode(true);
    popupMock.style.position = '';
    popupMock.style.visibility = 'hidden';
    box.appendChild(popupMock);

    // Force our popup to the very tippy top visually by making it the last
    // element on the page. The popup uses the highest z-index, but if other
    // elements use the same one, the last one on the page is the winner.
    // This interval ensures the GDPR popup is always the last thing on the
    // page. Always.
    //
    // In our case at Honeyfund we want to make sure the Intercomm button
    // doesn't cover the Accept button.
    const kingMaker = setInterval(function () {
        if (box.parentNode && box.parentNode.childNodes[box.parentNode.childNodes.length - 1] !== box) {
            box.parentNode.appendChild(box);
        }
    }, 250);
}

function cookieIsSet() {
    const pairs = document.cookie.split(';');
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].trim().split('=', 2);
        if (pair[0] === 'cookie_consent' && (pair[1] === 'accepted' || pair[1] === 'rejected')) {
            return true;
        }
    }
    return false;
}

function setCookie(value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = 'cookie_consent=' + value + '; Expires=' + expires.toGMTString() + '; Path=/' + secure + '; Domain=' + SHARED_COOKIE_DOMAIN + '; SameSite=Lax;';
}

function setSessionCookie() {
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = 'cookie_consent=rejected; Path=/' + secure + '; Domain=' + SHARED_COOKIE_DOMAIN + '; SameSite=Lax;';
}

function transitionOut(box, popup, onDone) {
    if (!box.getBoundingClientRect) { // some browsers don't have it
        onDone();
        return;
    }

    // if we can give a friendly animation, do so
    const boundingRect = box.getBoundingClientRect();

    // empty the box
    while (box.firstChild) {
        box.removeChild(box.firstChild);
    }

    // but keep the popup in there
    box.appendChild(popup);

    // the box can control its own size in this kind of browser
    box.style.minHeight = boundingRect.height + 'px';

    const timeToRemoval = 100;
    const loopTime = 10;
    const increment = boundingRect.height / (timeToRemoval / loopTime);

    let y = 0;

    const loop = setInterval(function () {
        y += increment;

        // Transition the popup down
        popup.style.bottom = '-' + y + 'px';

        // Just in case we are scrolled to the bottom of the screen, shrink the
        // containing box as well, so the page doesn't suddenly collapse on the
        // space it was taking up
        box.style.minHeight = (boundingRect.height - y) + 'px';
    }, loopTime);

    setTimeout(function () {
        clearInterval(loop);
        onDone();
    }, timeToRemoval);
}

function buildPopup(html, lang, onDone, onAcceptAll, onNecessaryOnly) {
    const sandbox = document.createElement('div');
    sandbox.innerHTML = html;
    const popup = sandbox.firstChild;

    const text = popup.getElementsByClassName('gdpr-text')[0];
    text.innerHTML = lang.html;

    const button = popup.getElementsByClassName('gdpr-accept-button')[0];
    button.innerText = lang.buttonText;
    if (button.addEventListener) {
        button.addEventListener('click', onAcceptAll);
    } else if (button.attachEvent) {
        button.attachEvent('onclick', onAcceptAll);
    }
 
    // Necessary Only button
    const necessaryButton = popup.getElementsByClassName('gdpr-necessary-button')[0];
    necessaryButton.innerText = lang.necessaryButtonText;
    if (necessaryButton.addEventListener) {
        necessaryButton.addEventListener('click', onNecessaryOnly);
    } else if (necessaryButton.attachEvent) {
        necessaryButton.attachEvent('onclick', onNecessaryOnly);
    }
 
    // Close (X) button — treated as Necessary Only
    const closeButton = popup.getElementsByClassName('gdpr-close-button')[0];
    if (closeButton.addEventListener) {
        closeButton.addEventListener('click', onNecessaryOnly);
    } else if (closeButton.attachEvent) {
        closeButton.attachEvent('onclick', onNecessaryOnly);
    }

    return popup;
}
